export default {
	account: {},
	contextualization: {
		timelines: [],
		panel: {
			visible: false,
			extended: true
		}
	}
}